export default __webpack_public_path__ + "static/83f47f5ca740961955c63c2b9e8ca0eb.webp";